<template>
  <div class="jmreport-report-page">
    <!-- :key 绑当前 token：重新登录换新 token 后 iframe 自动重挂，报表 tab 自愈（BUG-0023） -->
    <iframe
      :key="iframeKey"
      class="jmreport-report-page__iframe"
      :src="iframeSrc"
      frameborder="0"
    />
  </div>
</template>

<script>
import { getToken, getUserInfo } from '@/utils/auth'
import { appendCurrentToken } from './jmReportToken'

export default {
  name: 'JmReportIframe',
  props: {
    reportPath: {
      type: String,
      default: ''
    }
  },
  computed: {
    iframeSrc() {
      return appendCurrentToken(this.reportPath, this.getSessionId())
    },
    iframeKey() {
      return this.getSessionId() || 'no-token'
    }
  },
  methods: {
    getSessionId() {
      const getters = (this.$store && this.$store.getters) || {}
      const userInfo = getters.userInfo || getUserInfo() || {}
      return getters.token || userInfo.sessionId || getToken()
    }
  }
}
</script>

<style scoped>
.jmreport-report-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
}

.jmreport-report-page__iframe {
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}
</style>
